import { useSoundPath } from "hooks/useSoundPath";
import Cookies from "js-cookie";
import { CraftIdentityContext } from "pages/CraftIdentity";
import { CraftPredictionContext } from "pages/CraftPrediction";
import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { createAPI } from "services/api/api";

const CraftBuyInMarketplaceBtn = ({ status, id, name, type }) => {
  const { pathname } = useLocation();
  const api = createAPI();
  const playSound = useSoundPath();

  const scrollToCards = () => {
    const targetElement = document.querySelector(".cards-list__block--min");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getContext = () => {
    return pathname.includes("identity")
      ? CraftIdentityContext
      : CraftPredictionContext;
  };

  const { setMode, setMarketCards } = useContext(getContext());

  const submitHandler = () => {
    console.log(status, id, name, type);

    playSound("main");
    api
      .get(
        `/me/identities_matches_marketplace_list/params?type=${type}&value=${name}`
      )
      .then((response) => {
        setMarketCards(response.data.data);
      })
      .then(() => {
        setMode("purchase");
        Cookies.set("isBuyFromMarket", true);
        scrollToCards();
      })
      .catch((error) => console.log(error));
  };

  if (status === "Not Owned" && id !== -1) {
    return (
      <button
        className="card-details__craft-sublist-item-button"
        onClick={submitHandler}
      >
        Buy in Marketplace
      </button>
    );
  }
};

export default CraftBuyInMarketplaceBtn;
